import React, { Fragment } from "react";
import ModalComponent from "@/components/modal";
import { Flex } from "antd";
import ButtonComponent from "@/components/button/Button";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setModalOpen } from "@/reducers/commonSlice";

const SessionPurchasedSuccess = ({ isOpen }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <Fragment>
      <ModalComponent isOpen={isOpen} width={550}>
        <Flex vertical align="center" className="text-center">
          <img src="/assets/images/session-booked.png" style={{ height: "200px" }} />
          <div className="title-h4 text-center">Session Booked Successfully!</div>
          <div className="body-b1-2" style={{ margin: "10px 0" }}>
            You can review your session details in the 'My Sessions' section.
          </div>
          <Flex className="w-100" vertical gap="1rem">
            <ButtonComponent
              label="View My Session"
              varient="primary"
              className="w-100"
              onClick={() => {
                dispatch(setModalOpen(false));
                navigate("/sessions");
              }}
            />
            <ButtonComponent
              label="Go to Dashboard"
              varient=""
              className="w-100"
              onClick={() => {
                dispatch(setModalOpen(false));
                navigate("/dashboard");
              }}
            />
          </Flex>
        </Flex>
      </ModalComponent>
    </Fragment>
  );
};

export default SessionPurchasedSuccess;
